<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-2">
          <div class="card mini-stats-wid div-clickable h-75">
            <div class="card-body" @click="filtrarDocumentosPorStatus('0')">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">Pendente</p>
                  <h4 class="mb-0">{{ contagem.pendente }}</h4>
                </div>
                <div
                  class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-warning"
                >
                  <span class="indicadores"
                    ><i class="mdi mdi-folder-alert-outline font-size-20"></i
                  ></span>
                </div>
              </div>
              <div>
                <p class="text-muted font-size-12 mt-2">
                  Falta você incluir um arquivo!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card mini-stats-wid div-clickable h-75">
            <div class="card-body" @click="filtrarDocumentosPorStatus('1')">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">Em Análise</p>
                  <h4 class="mb-0">{{ contagem.analise }}</h4>
                </div>
                <div
                  class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-info"
                >
                  <span class="indicadores"
                    ><i class="mdi mdi-folder-clock-outline font-size-20"></i
                  ></span>
                </div>
              </div>
              <div>
                <p class="text-muted font-size-12 mt-2">
                  Estamos analisando o documento...
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card mini-stats-wid div-clickable h-75">
            <div class="card-body" @click="filtrarDocumentosPorStatus('99')">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">A assinar</p>
                  <h4 class="mb-0">{{ contagem.assinar }}</h4>
                </div>
                <div
                  class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                >
                  <span class="indicadores"
                    ><i class="mdi mdi-folder-edit font-size-20"></i
                  ></span>
                </div>
              </div>
              <div>
                <p class="text-muted font-size-12 mt-2">
                  Aguardando sua assinatura...
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card mini-stats-wid div-clickable h-75">
            <div class="card-body">
              <div class="d-flex" @click="filtrarDocumentosPorStatus('2')">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">Válido</p>
                  <h4 class="mb-0">{{ contagem.valido }}</h4>
                </div>
                <div
                  class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-success"
                >
                  <span class="indicadores"
                    ><i class="mdi mdi-folder-outline font-size-20"></i
                  ></span>
                </div>
              </div>
              <div>
                <p class="text-muted font-size-12 mt-2">
                  Está tudo certo com seu documento!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card mini-stats-wid div-clickable h-75">
            <div class="card-body">
              <div class="d-flex" @click="filtrarDocumentosPorStatus('3')">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">Inválido</p>
                  <h4 class="mb-0">{{ contagem.invalido }}</h4>
                </div>
                <div
                  class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-danger"
                >
                  <span class="indicadores"
                    ><i class="mdi mdi-folder-remove-outline font-size-20"></i
                  ></span>
                </div>
              </div>
              <div>
                <p class="text-muted font-size-12 mt-2">
                  Falta adequar algo no documento!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card mini-stats-wid div-clickable h-75">
            <div class="card-body">
              <div class="d-flex" @click="limparFiltragem()">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">Todos</p>
                  <h4 class="mb-0">{{ contagem.todos }}</h4>
                </div>
                <div
                  class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-secondary"
                >
                  <span class="indicadores"
                    ><i class="mdi mdi-folder-multiple-outline font-size-20"></i
                  ></span>
                </div>
              </div>
              <div>
                <p class="text-muted font-size-12 mt-2">Todos os documentos!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <b-form-group class="mb-3" label="Classificação">
                <multiselect
                  v-model="selectTpClassificacao"
                  placeholder="Selecione"
                  :show-labels="false"
                  label="name"
                  :options="optionTpClassificacao"
                  @input="gerenciarFiltragem()"
                />
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group class="mb-3" label="Tipo de Documento">
                <multiselect
                  v-model="selectTpDocumento"
                  placeholder="Selecione"
                  :show-labels="false"
                  label="ds_tipo_anexo"
                  :options="optionTpDocumento"
                  @input="gerenciarFiltragem()"
                />
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group class="mb-3" label="Filtrar por Status">
                <multiselect
                  v-model="selectStatus"
                  placeholder="Selecione"
                  :show-labels="false"
                  label="name"
                  :options="optionStatus"
                  @input="gerenciarFiltragem()"
                />
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group class="mb-3" label="Filtrar por Datas">
                <date-picker
                  v-model="rangeDeDatas"
                  range
                  value-type="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                  @change="gerenciarFiltragem()"
                  append-to-body
                />
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <b-form-group class="mb-3" label="Projetos">
                <multiselect
                  v-model="selectTpProjetos"
                  placeholder="Selecione"
                  :show-labels="false"
                  label="DISPLAY"
                  :options="optionProjetos"
                  @input="gerenciarFiltragem()"
                />
              </b-form-group>
            </div>
            <div class="col-md-4 d-flex justify-content-end align-items-center">
              <b-button class="mt-1" @click="limparFiltragem()">
                <i class="mdi mdi-broom"></i>
                Limpar Filtro
              </b-button>
              <router-link
                to="/perfilPessoal/gestaoDocumentos/0"
                v-if="tpProfile != 1"
              >
                <b-button variant="info" class="mt-1 mx-3">
                  <i class="mdi mdi-plus"></i>
                  Novo Documento
                </b-button>
              </router-link>
            </div>
          </div>
          <div class="row table-responsive">
            <b-table
              responsive="sm"
              :items="dadosDocumentos"
              :fields="camposDocumentos"
              per-page="10"
              :current-page="currentPage"
              striped
            >
              <template v-slot:cell(st_upload)="data">
                <h2
                  class="badge"
                  :class="{
                    'bg-warning': data.item.st_upload === '0',
                    'bg-info': data.item.st_upload === '1',
                    'bg-success': data.item.st_upload === '2',
                    'bg-danger': data.item.st_upload === '3',
                    'bg-primary': data.item.st_upload === '99',
                  }"
                >
                  {{ getStatusName(data.item.st_upload) }}
                </h2>
              </template>
              <template #cell(options)="data">
                <div class="d-flex">
                  <b-button
                    size="sm"
                    class="me-1"
                    v-if="
                      (!data.item.ds_titulo.includes('Envelope')) ||
                      (data.item.ds_titulo.includes('Envelope') && data.item.st_upload === '2')
                    "
                    @click="editarDoc(data.item)"
                    variant="primary"
                    :data-tooltip="
                      (data.item.ds_titulo.includes('Envelope') && data.item.st_upload === '2')
                        ? 'Visualizar'
                        : (data.item.st_upload === '0' || data.item.st_upload === '3' ? 'Editar' : 'Visualizar')
                    "
                    data-tooltip-location="left"
                  >
                    <i
                      class="mdi"
                      :class="{
                        'mdi-eye': (data.item.ds_titulo.includes('Envelope') && data.item.st_upload === '2') || (!data.item.ds_titulo.includes('Envelope') && data.item.st_upload === '2'),
                        'mdi-pencil': !data.item.ds_titulo.includes('Envelope') && (data.item.st_upload === '0' || data.item.st_upload === '1' || data.item.st_upload === '3')
                      }"
                    ></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div
              class="dataTables_paginate paging_simple_numbers float-end mb-3"
            >
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="this.dadosDocumentos.length"
                  :per-page="this.itemsPerPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
export default {
  components: {
    PageHeader,
    Multiselect,
  },

  data() {
    return {
      title: "Gestão de Documentos",
      items: [
        {
          text: "",
        },
      ],
      loading: true,
      currentPage: 1,
      itemsPerPage: 10,
      totalRows: 0,
      dadosDocumentos: [],
      dadosDocumentosBK: [],
      dadosDocFiltrados: [],
      camposDocumentos: [
        { key: "sq_upload", label: "Código" },
        {
          key: "tp_classificacao",
          label: "Classificação",
          formatter: (value) => {
            switch (value) {
              case "0":
                return "Documentação Pessoal";
              case "1":
                return "Documentação de Projeto";
              case "2":
                return "Documentação Pessoal/Projeto";
              case "3":
                return "Documentação Pessoal/Atualização";
              case "4":
                return "Documentação Interna";
              case "5":
                return "Documentação de Filiação";
            }
          },
        },
        {
          key: "ds_titulo",
          label: "Tipo de Documento",
        },
        {
          key: "cd_projeto",
          label: "Projeto",
        },
        {
          key: "st_upload",
          label: "Status",
          class: "alinharCelula",
        },
        {
          key: "dt_usuinc",
          label: "Data Inclusão",
          class: "alinharCelula",
          formatter: (value) => {
            if (value) {
              return (
                value.substring(0, 10).split("-").reverse().join("/") +
                value.substring(10)
              );
            } else {
              return "-";
            }
          },
        },
        {
          key: "dt_usualt",
          label: "Data Alteração",
          class: "alinharCelula",
          formatter: (value) => {
            if (value) {
              return (
                value.substring(0, 10).split("-").reverse().join("/") +
                value.substring(10)
              );
            } else {
              return "-";
            }
          },
        },
        {
          key: "options",
          label: "",
        },
      ],
      contagem: {
        pendente: 0,
        analise: 0,
        valido: 0,
        invalido: 0,
        assinar: 0,
      },
      valorFiltroAtual: null,
      selectTpClassificacao: "",
      optionTpClassificacao: [
        {
          value: "0",
          name: "Documentação Pessoal",
        },
        {
          value: "1",
          name: "Documentação de Projeto",
        },
        {
          value: "2",
          name: "Documentação Pessoal/Projeto",
        },
        {
          value: "3",
          name: "Documentação Pessoal/Atualização",
        },
        {
          value: "4",
          name: "Documentação Interna",
        },
        {
          value: "5",
          name: "Documentação de Filiação",
        },
      ],

      filtragem: false,

      respTpDocumento: [],

      optionStatus: [
        {
          value: "0",
          name: "Pendente",
        },
        {
          value: "1",
          name: "Em Análise",
        },
        {
          value: "2",
          name: "Válido",
        },
        {
          value: "3",
          name: "Inválido",
        },
        {
          value: "99",
          name: "A Assinar",
        },
      ],
      selectStatus: "",

      optionTpDocumento: [],
      selectTpDocumento: "",
      documentosInclusao: [],

      rangeDeDatas: "",

      docFiltrados: "",

      selectTpProjetos: "",
      optionProjetos: [],
      tpProfile: "",
      sqUpload: "",
    };
  },

  async created() {
    window.scrollTo(0, 0);
    this.$tools.fecharMenu();
    await this.prepararTela();
  },

  mounted() {
    this.calculateTotalPages();
  },

  watch: {
    dadosDocumentos: "calculateTotalPages",
  },

  methods: {
    async prepararTela() {
      await Promise.all([
        this.$http.get("api/cadastroCandidato/buscarDocumentos"),
        this.$http.get("api/cadastroCandidato/buscarTiposDocumento"),
        this.$http.get("api/cadastroCandidato/buscarProjetosDocumentos"),
        this.$http.get("api/cadastroCandidato/buscarProfileCadastro"),
      ])
        .then(([respDocumentos, respTpDocumento, respProjetos, profile]) => {
          this.loading = false;
          this.dadosDocumentos = respDocumentos.data;
          this.optionProjetos = respProjetos.data;
          this.dadosDocumentosBK = this.dadosDocumentos;
          this.docFiltrados = this.dadosDocumentosBK;
          this.rows = this.dadosDocumentos.length;
          this.contarElementosStUpload(this.dadosDocumentos);
          this.optionTpDocumento = respTpDocumento.data;
          // this.documentosInclusao = this.optionTpDocumento.filter(
          //   (item) =>
          //     (item.tp_classificacao === "0" ||
          //       item.tp_classificacao === "3") &&
          //     item.st_ativo === "A" &&
          //     item.tp_inclusao === "E"
          // );
          this.documentosInclusao = this.optionTpDocumento;
          this.tpProfile = profile.data;
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "error");
          this.loading = false;
        });
    },

    contarElementosStUpload(data) {
      const statusMap = {
        0: "pendente",
        1: "analise",
        2: "valido",
        3: "invalido",
        99: "assinar",
      };
      this.contagem = {
        pendente: 0,
        analise: 0,
        valido: 0,
        invalido: 0,
        assinar: 0,
        todos: data.length,
      };
      data.forEach((item) => {
        const stUpload = item.st_upload.toString();
        const status = statusMap[stUpload];
        if (status && this.contagem.hasOwnProperty(status)) {
          this.contagem[status] += 1;
        }
      });
    },

    getStatusName(stUpload) {
      const statusMap = {
        0: "Pendente",
        1: "Em Análise",
        2: "Válido",
        3: "Inválido",
        99: "A assinar",
      };
      return statusMap[stUpload] || "Indefinido";
    },

    editarDoc(item) {
      if (item.tp_inclusao === "G") {
        this.$router.push("/perfilPessoal/gestaoDocumentos/" + item.sq_upload);
        // this.$router.push("/assinaturaEletronica");
      } else {
        this.$router.push("/perfilPessoal/gestaoDocumentos/" + item.sq_upload);
      }
    },

    habilitarBtnExcluir(item) {
      if (item.st_upload === "1" && !item.ds_titulo.includes('Envelope')) {
        return this.documentosInclusao.find(
          (el) => el.ds_tipo_anexo == item.ds_titulo
        );
      }
      return;
    },

    calculateTotalPages() {
      this.totalRows = this.dadosDocumentos.length;
      this.currentPage = 1;
    },

    gerenciarFiltragem() {
      this.docFiltrados = this.dadosDocumentosBK;

      if (this.selectTpDocumento) {
        this.docFiltrados = this.docFiltrados.filter(
          (objeto) =>
            objeto.ds_tipo_anexo === this.selectTpDocumento.ds_tipo_anexo
        );
      }

      if (this.selectTpClassificacao) {
        this.docFiltrados = this.docFiltrados.filter(
          (objeto) =>
            objeto.tp_classificacao === this.selectTpClassificacao.value
        );
      }

      if (this.selectTpProjetos) {
        this.docFiltrados = this.docFiltrados.filter(
          (objeto) => objeto.cd_projeto === this.selectTpProjetos.VALUE
        );
      }

      if (this.selectStatus) {
        this.docFiltrados = this.docFiltrados.filter(
          (objeto) => objeto.st_upload === this.selectStatus.value
        );
      }

      if (this.rangeDeDatas) {
        this.docFiltrados = this.filtrarDocumentosPorData();
      }

      this.dadosDocumentos = this.docFiltrados;
    },

    filtrarDocumentosPorStatus(valorFiltro) {
      if (this.selectStatus.value === valorFiltro.toString()) {
        this.selectStatus = "";
      } else {
        this.selectStatus = this.optionStatus.find(
          (el) => el.value == valorFiltro
        );
      }
      this.gerenciarFiltragem();
    },

    filtrarDocumentosPorData() {
      const startDate = this.rangeDeDatas[0];
      const endDate = this.rangeDeDatas[1];
      // Filtrar o objeto pelo intervalo de datas fornecido
      if (startDate !== null && endDate !== null) {
        return this.docFiltrados.filter((item) => {
          const dateUsuinc = item.dt_usuinc;
          const dateUsualt = item.dt_usualt;
          return (
            (dateUsuinc >= startDate && dateUsuinc <= endDate) ||
            (dateUsualt >= startDate && dateUsualt <= endDate)
          );
        });
      }
      return this.docFiltrados;
    },

    limparFiltragem() {
      this.selectTpClassificacao = "";
      this.selectTpDocumento = "";
      this.selectTpProjetos = "";
      this.selectStatus = "";
      this.rangeDeDatas = "";
      this.dadosDocumentos = this.dadosDocumentosBK;
    },
  },
};
</script>

<style>
.indicadores {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 500;
  height: 100%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100%;
}
</style>